import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { BehaviorSubject, merge, Observable, of } from 'rxjs';
import { catchError, first, map, share, switchMap } from 'rxjs/operators';
import { Account, AccountService } from './account';
import { Site, SiteService } from './site';

interface AppConfigResponse {
  data: AppConfig;
}

export interface AppConfig {
  partner_id?: string;
  market_id?: string;
}

@Injectable()
export class AppConfigService {
  config$$: BehaviorSubject<AppConfig> = new BehaviorSubject<AppConfig>(undefined);
  readonly config$: Observable<AppConfig> = this.config$$.asObservable();

  constructor(
    private http: HttpClient,
    private siteService: SiteService,
    private account: AccountService,
    private alertService: SnackbarService,
  ) {
    merge(this.account.result(), this.siteService.get())
      .pipe(
        map((res: Account | Site) => res.accountId),
        switchMap((accountId: string) => {
          if (accountId.startsWith('AG-')) {
            return this.loadAppConfig(accountId);
          }
          return of({ show_advanced_features: false });
        }),
        first(),
        share(),
      )
      .subscribe((config: AppConfig) => this.config$$.next(config));
  }

  private loadAppConfig(accountId: string): Observable<AppConfig> {
    return this.http.get<AppConfigResponse>(`api/v1/account/${accountId}/app-config/`).pipe(
      map((resp: AppConfigResponse) => resp.data),
      catchError(() => {
        this.alertService.openErrorSnack('There was an error getting the app config');
        return of({});
      }),
    );
  }
}
